export default __webpack_public_path__ + "static/media/baadi.619242ec.svg";